import { Injectable } from '@angular/core';

const WIDGET_STATE_KEY = 'ui-widget-state';

export interface WidgetState {
  name: string;
  width: number;
  height: number;
}

@Injectable({
  providedIn: 'root'
})
export class GeoWidgetStateService {

  private loadAll(): WidgetState[] {
    const data = localStorage.getItem(WIDGET_STATE_KEY);
    return data ? JSON.parse(data) : [];
  }

  private saveAll(states: WidgetState[]) {
    localStorage.setItem(WIDGET_STATE_KEY, JSON.stringify(states));
  }

  saveState(widgetName: string, size: { width: number; height: number }) {
    const states = this.loadAll();

    const existing = states.find(s => s.name === widgetName);

    if (existing) {
      existing.width = size.width;
      existing.height = size.height;
    } else {
      states.push({
        name: widgetName,
        width: size.width,
        height: size.height
      });
    }

    this.saveAll(states);
  }

  loadState(widgetName: string): WidgetState | null {
    const states = this.loadAll();
    return states.find(s => s.name === widgetName) || null;
  }
}
